import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { PercentagePipe } from '../pipes/percentage.pipe';

@Directive({
    selector: '[percentage]',
    standalone: false
})
export class PercentageDirective implements OnInit {

  private el: HTMLInputElement

  constructor(
    elementRef: ElementRef, 
    private percentagePipe: PercentagePipe
  ) {
    // console.error('PercentageDirective -> constructor', elementRef, formControl)

    this.el = elementRef.nativeElement;
  }

  ngOnInit() {
    // console.error('PercentageDirective -> ngOnInit', this.el.value)

    this.el.value = this.formatNumber(this.el.value)
  }

  @HostListener('keyup', ['$event.target.value'])
  onKeyUp(value: string) {
    // console.error('PercentageDirective -> onKeyUp', value)

    this.el.value = this.formatNumber(value)
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    // console.error('PercentageDirective -> onKeyDown', e)
    if (
      [46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
      // Ctrl+A
      (e.keyCode == 65 && (e.ctrlKey || e.metaKey)) ||
      // Ctrl+C
      (e.keyCode == 67 && (e.ctrlKey || e.metaKey)) ||
      // Ctrl+V
      (e.keyCode == 86 && (e.ctrlKey || e.metaKey)) ||
      // Ctrl+X
      (e.keyCode == 88 && (e.ctrlKey || e.metaKey)) ||
      // Home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }
    // only allow numbers
    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      // console.error('PercentageDirective -> onKeyDown', 'preventDefault', e.key, e.keyCode)

      e.preventDefault();
    }
  }

  public formatNumber(s: string): string {
    // console.error('PercentageDirective -> formatNumber', 's', s, 's.length', s?.length)
    
    if(s?.indexOf('%') <= 0 && s.length > 2)
      s = s.substring(0, s.length-1)
    // console.error('PercentageDirective -> formatNumber', 's', s)
    const value = this.percentagePipe.transform(s)

    return value
  }
}